export default "__VITE_ASSET__DY7KnvSg__"